module.exports = __webpack_public_path__ + "img/08.959cdad4.jpg";